import { render, staticRenderFns } from "./IconTextFont.vue?vue&type=template&id=c6af4f3c&"
import script from "./IconTextFont.vue?vue&type=script&lang=js&"
export * from "./IconTextFont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6af4f3c')) {
      api.createRecord('c6af4f3c', component.options)
    } else {
      api.reload('c6af4f3c', component.options)
    }
    module.hot.accept("./IconTextFont.vue?vue&type=template&id=c6af4f3c&", function () {
      api.rerender('c6af4f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTextFont.vue"
export default component.exports